export const RECONCILIATION_STATUS_META = {
    reconciled: { badgeClass: 'badge-green', label: 'Reconciled', discrepancy: '—', valueField: 'amount' },
    amount_mismatch: { badgeClass: 'badge-yellow', label: 'Amount Mismatch', discrepancy: 'Disbursement Amount', valueField: 'amount' },
    tenure_mismatch: { badgeClass: 'badge-yellow', label: 'Tenure Mismatch', discrepancy: 'Tenure', valueField: 'tenure' },
    emi_mismatch: { badgeClass: 'badge-yellow', label: 'EMI Mismatch', discrepancy: 'EMI Amount', valueField: 'emi' },
    missing_from_feemonk: { badgeClass: 'badge-red', label: 'Missing (FeeMonk)', discrepancy: 'Not in our records', valueField: 'amount' },
    missing_from_fibe: { badgeClass: 'badge-red', label: 'Missing (Fibe)', discrepancy: "Not in Fibe's file", valueField: 'amount' },
    irr_data_missing: { badgeClass: 'badge-blue', label: 'IRR Data Missing', discrepancy: 'IRR data missing in sanction details', valueField: 'amount' },
    skipped: { badgeClass: 'badge-gray', label: 'Skipped', discrepancy: 'Row skipped', valueField: 'amount' },
};

const VALUE_FIELD_TO_RECORD_FIELDS = {
    amount: { fibe: 'fibeAmount', feemonk: 'feemonkAmount' },
    tenure: { fibe: 'fibeTenure', feemonk: 'feemonkTenure' },
    emi: { fibe: 'fibeEmi', feemonk: 'feemonkEmi' },
};

export function getReconciliationStatusMeta(status) {
    return RECONCILIATION_STATUS_META[status] ?? { badgeClass: 'badge-gray', label: status, discrepancy: '—', valueField: 'amount' };
}

export function getDiscrepancyValues(record) {
    const meta = getReconciliationStatusMeta(record.status);
    const fields = VALUE_FIELD_TO_RECORD_FIELDS[meta.valueField];
    return {
        valueField: meta.valueField,
        fibeValue: record[fields.fibe],
        feemonkValue: record[fields.feemonk],
    };
}
